<h5>{{'studyQualityEvaluation_title' | translate}}</h5>

<div class="row">
    <div class="data-value col-sm">
        <label>{{'planSummary_lblResident' | translate}}</label>
        <div>
            {{resident.Name}} {{resident.Surname}}, {{residentNumber}}
        </div>
    </div>

    <div class="data-value col-sm">
        <label>{{'planSummary_lblSpeciality' | translate}}</label>
        <div>
            <ng-container *ngIf="resident.SpecialityName; else noValue">
                {{resident.SpecialityName}}
            </ng-container>
        </div>
    </div>

    <div class="data-value col-sm">
        <label>{{'planSummary_lblSupervisor' | translate}}</label>
        <div>
            <ng-container *ngIf="supervisor; else noValue">
                {{supervisor.FirstName}} {{supervisor?.LastName}}
            </ng-container>
        </div>
    </div>
</div>

<div class="year-selector">
    <div>
        <label class="form-label">{{'studyQualityEvaluation_lblStudyYear' | translate}}</label>
        <button *ngFor="let y of yearOptions"
                class="btn btn-outline{{y.value == selectedYear ? '-primary' : ''}}"
                type="button"
                [disabled]="y.disabled || (isEdit && y.value != selectedYear)"
                (click)="changeYear(y.value)">
            {{y.value}}
        </button>
    </div>
</div>

<form #form="ngForm" class="was-validated">
    <ng-container *ngIf="selectedYear">
        <ul ngbNav #nav="ngbNav" [(activeId)]="activeNavId" class="nav-tabs">
            <li [ngbNavItem]="i + 1" [disabled]="isEdit" *ngFor="let tab of tabs; let i = index">
                <a ngbNavLink class="hidden-{{tabs.length > 2 ? 'md' : 'sm'}}-down">{{tab.title | translate}}</a>
                <ng-template ngbNavContent>
                    <ng-container [ngSwitch]="tab.id">
                        <div class="mt-3">
                            <app-plan-summary-quality-evaluation-form *ngSwitchCase="'firstHalf'"
                                                                      [data]="currentEvaluationFirstHalf"
                                                                      [model]="model.firstHalf"
                                                                      [options]="options"
                                                                      [studyYear]="selectedYear"
                                                                      [previous]="model.prevYearHalf"
                                                                      [isEdit]="isEdit"></app-plan-summary-quality-evaluation-form>

                            <app-plan-summary-quality-evaluation-form *ngSwitchCase="'secondHalf'"
                                                                      [data]="currentEvaluationSecondHalf"
                                                                      [model]="model.secondHalf"
                                                                      [options]="options"
                                                                      [studyYear]="selectedYear"
                                                                      [previous]="model.firstHalf"
                                                                      [isEdit]="isEdit"></app-plan-summary-quality-evaluation-form>

                            <ng-container *ngSwitchCase="'midtermExams'">
                                <app-table [columns]="midtermExamColumns" [rows]="midtermExams">
                                    <ng-template #rowTemplate let-row>
                                        <tr>
                                            <td>
                                                <div>
                                                    <strong class="hidden-md-up">{{'studyQualityEvaluation_lblLocation' | translate}}</strong>
                                                    <div class="hidden-sm-down">{{row.Location}}</div>
                                                    <div class="hidden-md-up">{{row.Location || '-'}}</div>
                                                </div>

                                                <div class="text-sub text-nowrap hidden-lg-up hidden-sm-down">
                                                    {{row.Date}} {{row.Time}}
                                                </div>

                                                <div class="text-nowrap hidden-md-up mt-1">
                                                    <strong>{{'studyQualityEvaluation_lblTime' | translate}}</strong>
                                                    <div>{{row.date | appDate:'datetime'}}</div>
                                                </div>

                                                <div class="hidden-md-up mt-1">
                                                    <strong>{{'studyQualityEvaluation_lblMembers' | translate}}</strong>
                                                    <div>{{row.memberString || '-'}}</div>
                                                </div>

                                                <div class="hidden-md-up mt-1">
                                                    <strong>{{'studyQualityEvaluation_lblGrade' | translate}}</strong>
                                                    <div>{{row.Grade || '-'}}</div>
                                                </div>
                                            </td>
                                            <td class="hidden-md-down text-nowrap">{{row.date | appDate:'datetime'}}</td>
                                            <td class="hidden-sm-down">{{row.memberString}}</td>
                                            <td class="hidden-sm-down">{{row.Grade}}</td>
                                        </tr>
                                    </ng-template>
                                </app-table>
                            </ng-container>
                        </div>
                    </ng-container>
                </ng-template>
            </li>
            <li ngbDropdown class="nav-item hidden-{{tabs.length > 2 ? 'lg' : 'md'}}-up" placement="bottom-start">
                <a class="nav-link" [class.active]="true" ngbDropdownToggle>
                    {{tabs[activeNavId - 1].title | translate}}
                </a>
                <div ngbDropdownMenu class="more-tab-menu">
                    <button ngbDropdownItem *ngFor="let n of tabs; let i = index" (click)="nav.select(i + 1)" [disabled]="i == activeTabId - 1">
                        {{n.title | translate}}
                    </button>
                </div>
            </li>
        </ul>

        <div [ngbNavOutlet]="nav"></div>

        <div class="mt-3" *ngIf="activeTab.info()">
            <app-alert level="info">{{activeTab.info()}}</app-alert>
        </div>

        <div class="form-actions" *ngIf="activeTab && isSupervisor">
            <button class="btn btn-outline" type="button" (click)="edit()" *ngIf="!isEdit && activeTab.canEdit()">
                <i class="fi fi-rs-pencil"></i>
                {{'studyQualityEvaluation_btnEdit' | translate}}
            </button>

            <button class="btn btn-outline" type="button" (click)="cancel()" *ngIf="isEdit">
                {{'studyQualityEvaluation_btnCancel' | translate}}
            </button>

            <button class="btn btn-primary" type="button" (click)="save()" *ngIf="isEdit" [disabled]="!isValid">
                {{'studyQualityEvaluation_btnSave' | translate}}
            </button>

            <button class="btn btn-outline-primary" type="button" (click)="save(true)" *ngIf="isEdit && activeTab.canSubmit()" [disabled]="!isValid">
                <i class="fi fi-rs-paper-plane"></i>
                {{'studyQualityEvaluation_btnSaveAndSubmit' | translate}}
            </button>
        </div>
    </ng-container>
</form>

<div class="form-actions" *ngIf="isForResidencyReview">
    <button class="btn btn-outline" (click)="rejectEvaluation()" type="button">
        {{ 'studyQualityEvaluation_btnReject' | translate}}
    </button>

    <button class="btn btn-outline-primary" *ngIf="movedToNextYear" (click)="changeCondition()" type="button">
        {{ 'studyQualityEvaluation_btnChangeCondition' | translate}}
    </button>

    <button class="btn btn-primary" (click)="acceptEvaluation()" type="button">
        {{ 'studyQualityEvaluation_btnAccept' | translate}}
    </button>
</div>

<ng-template #noValue>{{'planSummary_undefined' | translate}}</ng-template>
